export default __webpack_public_path__ + "static/media/03-1.8690ccd1.jpg";